<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="139" viewBox="0 0 56 139" fill="none">
    <path d="M55 1.54972e-06V138H-5.96046e-08" stroke="#000711" />
  </svg>
</template>
